/**
 * The Ollie button's "noticed" dot: only when something is new to this
 * person, so it means Ollie has been working rather than constant noise.
 */

export const OLLIE_FAB_ARIA_LABEL = 'Open Ollie assistant'

export const ollieNoticedLabel = count =>
  count === 1 ? 'Ollie noticed 1 thing' : `Ollie noticed ${count} things`

/**
 * @param {Array<object>} newFindings — `listNewOllieFindings` output
 * @returns {{ show: boolean, count: number, label: string|null, ariaLabel: string }}
 */
export const buildOllieFabNotice = newFindings => {
  const count = Array.isArray(newFindings) ? newFindings.length : 0
  if (count < 1) {
    return {
      show: false,
      count: 0,
      label: null,
      ariaLabel: OLLIE_FAB_ARIA_LABEL,
    }
  }
  const label = ollieNoticedLabel(count)
  return {
    show: true,
    count,
    label,
    ariaLabel: `${OLLIE_FAB_ARIA_LABEL}. ${label}`,
  }
}
